import React from "react";

interface DialogCloseProps {
    children?: any,
    text?: string,
    icon?: string,
    left?: boolean,
    hidden?: boolean,
    disabled?: boolean,
    tooltip?: string,
    onClick?: Function
};

class DialogClose extends React.Component<DialogCloseProps> {

    onClick(event) {
        this.props.onClick(event);
    }
    
    render() {

        return (
        <button className={`dialog-close no-image${this.props.left ? " left" : ""}`}
                style={{ display: this.props.hidden === true ? "none" : "initial" }}
                disabled={this.props.disabled}
                data-tip={this.props.tooltip}
                onClick={ev => this.onClick(ev)}>
            {this.props.icon && <i>{this.props.icon}</i>}
            <span>{this.props.text ?? "Close"}</span>
        </button>
        );

    }

}

export default DialogClose;